import React from 'react';
import classNames from 'classnames';

interface DescriptionProps {
  /** Content to display as DefinitionListDescription. */
  children: React.ReactNode;
  /** CSS class name */
  className?: string | string[];
}

/** Renders children in DescriptionListDefinition style. */
const Description = ({ children, className }: DescriptionProps) => {
  return <dd className={classNames(className, 'col-md-8')}>{children}</dd>;
};

Description.defaultProps = {
  className: null,
};

export default Description;
